import { useRef, useState, type ReactElement, type SyntheticEvent } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/v2/tooltip";
import { isOverflowing } from "@/lib/utils/isOverflowing";

type TruncatedTooltipProps = {
  text: string;
  children: ReactElement;
};

export function TruncatedTooltip({ text, children }: TruncatedTooltipProps) {
  const triggerRef = useRef<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  const trackTrigger = (event: SyntheticEvent<HTMLElement>) => {
    triggerRef.current = event.currentTarget;
  };

  const handleOpenChange = (next: boolean) =>
    setOpen(next && triggerRef.current !== null && isOverflowing(triggerRef.current));

  return (
    <Tooltip open={open} onOpenChange={handleOpenChange}>
      <TooltipTrigger asChild onPointerMove={trackTrigger} onFocus={trackTrigger}>
        {children}
      </TooltipTrigger>
      <TooltipContent className="max-w-sm break-words">{text}</TooltipContent>
    </Tooltip>
  );
}
